const DEFAULT_DURATION = 600;

const initialState = {
  filters: [], // List of filters to show from API
  selectedFilters: [], // selected filters
  duration: DEFAULT_DURATION, // 10 min in seconds
  position: undefined,
  radius: 0,
  include_is_unavailable: true,
};

export default initialState;
